import React from 'react'
import { Title, Paragraph, DARK_GRAY_80, DARK_GRAY_60 } from '@omnilert/components'

import Logo from '@assets/img/omnilert_mini_2.png'

import useStyles from './not-found.style'

const NotFound = () => {
  const classes = useStyles()
  return (
    <section
      className={classes.section}
    >
      <div className={classes.container}>
        <div className={classes.column}>
          <Title
            className={classes.title}
            color={DARK_GRAY_80}
            size='lg'
          >Sorry, this page isn't available
          </Title>
          <Paragraph
            className={classes.paragraph}
            color={DARK_GRAY_60}
            size='lg'
          >Please contact your system administrator if you think you have received this message in error
          </Paragraph>
          <img
            alt='logo'
            className={classes.logo}
            src={Logo}
          />
        </div>
      </div>
    </section>
  )
}

export default NotFound
